module.exports = __webpack_public_path__ + "static/media/amex.25ae0c2c.svg";